import React, { memo, useCallback } from "react";
import { useSelector } from "react-redux";
import { Container, Grid, Paper, Box } from "@mui/material";
import { ApplicationState } from "../../../store";
import { CardPromptType } from "../../../store/cardPrompt/types";

import PageHeading from "../../../common/pageHeading/PageHeading";
import useSession from "../../../effects/useSession";
import Layout from "../../Layout";
import pageStyles from "../../pageStyles";

import ItemDetailViewSection, {
  Item,
} from "../../../common/item/ItemDetailViewSection";
import SectionWrapper from "../../../common/pageSections/SectionWrapper";

function CardPromptView() {
  const classes = pageStyles();
  const session = useSession();
  const selected = useSelector<ApplicationState>(
    (store) => store.cardPrompt.selected
  ) as CardPromptType;

  const renderCardPromptView = useCallback(
    (data: CardPromptType | undefined) => {
      if (data) {
        const { attributes: at } = data;
        const cardPromptItem: Item[] = [
          { fieldName: "Name", fieldValue: at.Name },
        ];

        return (
          <SectionWrapper title="Card Prompts">
            {at.Bin.map((bin, idx) => (
              <ItemDetailViewSection
                key={idx}
                sectionName={`Card Bin ${cardPromptItem[0].fieldValue}`}
                itemData={cardPromptItem}
                binRange={bin.Range}
                binPrompt={bin.Prompt}
                isChild
              />
            ))}
          </SectionWrapper>
        );
      } else {
        return null;
      }
    },
    [selected]
  );

  return (
    <Layout sessionData={session}>
      <main className={classes.content}>
        <div className={classes.appBarSpacer} />
        <Container maxWidth="lg" className={classes.container}>
          <Grid container spacing={3}>
            <Grid item xs={12} md={12} lg={12}>
              <Paper>
                <PageHeading heading="View Card Prompt" />
              </Paper>
            </Grid>
            <Grid item xs={12}>
              <Paper className={classes.paper}>
                <Box style={{ position: "relative" }}>
                  {renderCardPromptView(selected)}
                </Box>
              </Paper>
            </Grid>
          </Grid>
        </Container>
      </main>
    </Layout>
  );
}

export default memo(CardPromptView);
